import SI, { Expansion } from '../Common/SI'
import './ExpansionIndicator.css'

export interface ExpansionIndicatorProps {
	expansion: Expansion
}

export function ExpansionIndicator(props: ExpansionIndicatorProps): JSX.Element {

	return (
		<span
			className={`expansion expansion-${SI.expansionClass.get(props.expansion)}`}
			title={props.expansion}>
			&#x2b24;
		</span>
	)
}
